import { render } from "./pb-leadertextblock.vue?vue&type=template&id=f68b299a"
import script from "./pb-leadertextblock.vue?vue&type=script&lang=js"
export * from "./pb-leadertextblock.vue?vue&type=script&lang=js"

import "./pb-leadertextblock.vue?vue&type=style&index=0&id=f68b299a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__